"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultState = void 0;
const defaultState = exports.defaultState = {
  marketingSubscriptionAccepted: false,
  licenceAccepted: false
};